import {
  assertionPayload,
  publicKeyRequestOptions,
  webAuthnAvailable
} from '../utils/webauthn.js'

async function signalCurrentUserDetails() {
  const detailsElement = document.querySelector('[data-webauthn-current-user-details]');
  if (!detailsElement) return;

  try {
    const signal = window.PublicKeyCredential?.signalCurrentUserDetails;
    if (typeof signal === 'function') {
      await signal.call(window.PublicKeyCredential, JSON.parse(detailsElement.textContent));
    }
  } catch {
    // Credential provider synchronization is best effort and must not affect sign-in.
  } finally {
    window.location.replace(detailsElement.dataset.continueTo);
  }
}

function initializePasskeyChallenge() {
  const root = document.querySelector('[data-passkey-challenge]');
  if (!root) return;

  const form = root.querySelector('[data-passkey-form]');
  const status = root.querySelector('[data-passkey-status]');
  const error = root.querySelector('[data-passkey-error]');
  const retry = root.querySelector('[data-passkey-retry]');
  const options = JSON.parse(root.querySelector('[data-passkey-options]').textContent);
  const messages = JSON.parse(root.querySelector('[data-passkey-messages]').textContent);

  function setValue(name, value) {
    const field = form.querySelector(`[name="${name}"]`);
    field.disabled = value == null;
    field.value = value ?? '';
  }

  function showError(message, retryable = true) {
    status.textContent = '';
    status.hidden = true;
    error.textContent = message;
    error.hidden = false;
    retry.hidden = !retryable;
  }

  async function authenticate() {
    error.hidden = true;
    retry.hidden = true;
    status.hidden = false;
    status.textContent = messages.waiting;

    let assertion;
    try {
      assertion = await navigator.credentials.get({
        publicKey: publicKeyRequestOptions(options)
      });
    } catch (exception) {
      showError(exception.name === 'NotAllowedError' ? messages.cancelled : messages.error);
      return;
    }

    const credential = assertionPayload(assertion);

    status.textContent = messages.verifying;
    setValue('credential[id]', credential.id);
    setValue('credential[rawId]', credential.rawId);
    setValue('credential[type]', credential.type);
    setValue('credential[response][authenticatorData]', credential.response.authenticatorData);
    setValue('credential[response][clientDataJSON]', credential.response.clientDataJSON);
    setValue('credential[response][signature]', credential.response.signature);
    setValue('credential[response][userHandle]', credential.response.userHandle);
    form.submit();
  }

  if (!webAuthnAvailable()) {
    showError(messages.unsupported, false);
    return;
  }

  retry.addEventListener('click', authenticate);
  authenticate();
}

document.addEventListener('DOMContentLoaded', () => {
  signalCurrentUserDetails();
  initializePasskeyChallenge();
});
